import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimComment.Delete.IRequest;
type Response = Api.Core.ClaimComment.Delete.IResponse;
type Headers = Api.Core.ClaimComment.Delete.IHeaders;
const url = '/api/Claims/ClaimComment/:id';
export default async function claimCommentDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
